

import {DisplayForms, AppBlocks, ViewPort, AppLink as Link, linkPopup, AiModal, DeleteModal} from "../components/helpers" 
import data from "../components/icons";

const Page = function({publishPage, langSettings, data, callback}) {
    if(!langSettings) {
        langSettings = {}
    }
    let previewButton =  "";
    return   <div className="w-100 h-100 position-relative">
          
                <div className={`wb-header`} style={{top:0}}>
                    <div className="wb-col d-flex d-none">
                        <a  className="wb-text ps-0"><i className="icon-left-open"></i> {langSettings.back}</a>
                    </div>
                    <ViewPort change={function(){

                    }} unselect={function(){

                    }} />
                   
                    <div className="wb-col">
                        {previewButton}
                        <a className="btn-publish" data-type="publish" onClick={publishPage}>{langSettings.save}</a>
                    </div>
                </div>
        <textarea className="w-100 p-3" defaultValue={data.data} style={{height:"calc(100% - 55px)", position: "relative",
    top: "55px"}} onChange={function(e){
        callback(e.currentTarget.value.trim());
    }}></textarea>
    </div>

}
export default Page;